import { observer } from "mobx-react-lite";
import { useTranslations } from "next-intl";

import {
  CONTROLS_ROW_BUTTON_CLASS_NAME,
  CONTROLS_ROW_BUTTON_WRAPPER_CLASS_NAME,
  CONTROLS_ROW_LABEL_CLASS_NAME,
} from "@/components/doc/left-sidebar/controlsRowStyles";
import { useHintHover } from "@/components/hints/useHintHover";
import { Icon } from "@/components/icons/Icon";
import { Sidebar } from "@/components/sidebar";
import { useStore } from "@/store";
import { twMerge } from "@/utils/twMerge";

import { useCreateInTree } from "./useCreateInTree";

export const CreateDocButton = observer(function CreateDocButton({
  hasText,
}: {
  hasText?: boolean;
}) {
  const { documentTree } = useStore();
  const t = useTranslations();
  const newDocumentHintHandlers = useHintHover("newDocument");
  const { createDocumentInTree } = useCreateInTree("top_panel");

  const createDoc = async () => {
    await createDocumentInTree();
    if (documentTree.drafts) {
      documentTree.openFolder(documentTree.drafts);
    }
  };

  return (
    <Sidebar.Button
      {...newDocumentHintHandlers}
      onClick={createDoc}
      icon={<Icon name="Add" className={twMerge("sm:w-[28px] sm:h-[28px]", hasText && "mr-1")} />}
      title={hasText ? undefined : t("documentsSidebar.newDocument")}
      className={
        hasText
          ? twMerge(CONTROLS_ROW_BUTTON_CLASS_NAME, CONTROLS_ROW_LABEL_CLASS_NAME)
          : "h-9.5 w-auto text-gray-500"
      }
      wrapperClassName={hasText ? CONTROLS_ROW_BUTTON_WRAPPER_CLASS_NAME : undefined}
    >
      {hasText && t("documentsSidebar.newDocumentShort")}
    </Sidebar.Button>
  );
});
